import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMutation } from 'react-query';
import { verifyEmail } from 'api/authentication/authen.api';
import {
  ERROR_CONFIRM_SIGNUP_EMAIL_PATH,
  SUCCESS_CONFIRM_SIGNUP_EMAIL_PATH,
} from 'constant/authenticationPath';
import { Spin } from 'antd';
import { useRecoilState } from 'recoil';
import {
  authenticationToken,
  userInformation,
} from 'recoil/atom/authentication';
import { menuSelected } from 'recoil/atom/listMenu';
import { queryClient } from 'api/config/queryClient';

const SignUpVerifyEmail = () => {
  const navigate = useNavigate();
  const [, setUserToken] = useRecoilState(authenticationToken);
  const [, setUserInformation] = useRecoilState(userInformation);
  const [, setMenuSelected] = useRecoilState(menuSelected);

  const handleClearStorage = () => {
    setUserToken({
      accessToken: '',
      passwordExpiredRemainingDay: 0,
    });
    setUserInformation({
      email: '',
      firstName: '',
      lastName: '',
      role: '',
      approveStatus: '',
      userId: 0,
    });
    setMenuSelected({
      id: 0,
      label: '',
      path: '',
    });
    queryClient.removeQueries();
  };

  const { mutate, isLoading } = useMutation({
    mutationFn: verifyEmail,
    onSuccess: () => {
      handleClearStorage();
      navigate(`/${SUCCESS_CONFIRM_SIGNUP_EMAIL_PATH}`);
    },
    onError: () => {
      handleClearStorage();
      navigate(`/${ERROR_CONFIRM_SIGNUP_EMAIL_PATH}`);
    },
  });

  useEffect(() => {
    const hash = window.location.hash;
    const queryString = hash.split('?')[1];

    if (queryString) {
      const params = new URLSearchParams(queryString);
      const payload = {
        email: params.get('email'),
        token: params.get('token'),
      };
      mutate(payload);
    }
  }, [mutate]);

  return (
    <div className="confirm-signup-email">
      <Spin spinning={isLoading} />
    </div>
  );
};

export default SignUpVerifyEmail;
